<template>
    <el-dialog
        class="add-currency"
        :visible.sync="addVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Add Currency"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form
                ref="addForm"
                :model="addForm"
                :rules="rules"
                label-width="70px"
            >
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="Name" prop="name" size="small">
                            <el-input
                                v-model="addForm.name"
                                placeholder="Please input name"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="Code" prop="code" size="small">
                            <el-input
                                v-model="addForm.code"
                                placeholder="Please input code"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="Symbol" prop="symbol" size="small">
                            <el-input
                                v-model="addForm.symbol"
                                placeholder="Please input symbol"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >Save</el-button
            >
            <el-button size="small" @click="addVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    data() {
        return {
            addForm: {
                name: "",
                code: "",
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: "Please input name",
                    },
                ],
                code: [
                    {
                        required: true,
                        message: "Please input code",
                    },
                ],
                symbol: [
                    {
                        required: true,
                        message: "Please input symbol",
                    },
                ],
            },
        };
    },
    methods: {
        closeDialog() {
            this.addForm = {
                name: "",
                code: "",
            };
            this.$refs["addForm"].clearValidate();
            this.$refs["addForm"].resetFields();
            this.$emit("update:addVisible", false);
        },
        save() {
            this.$refs["addForm"].validate((valid) => {
                if (valid) {
                    cmofferApi
                        .currencyList(
                            {
                                ...this.addForm,
                            },
                            "post"
                        )
                        .then((res) => {
                            if (res) {
                                this.$message.success(
                                    this.$i18n.locale == "zh"
                                        ? "新增成功"
                                        : "Success"
                                );
                                this.$parent[this.funcName] &&
                                    this.$parent[this.funcName]();
                                this.closeDialog();
                            }
                        });
                }
            });
        },
    },
    props: {
        addVisible: Boolean,
        funcName: String,
    },
    watch: {
        addVisible(val) {},
    },
};
</script>
<style lang="scss" scoped>
.add-currency {
    .container {
    }
}
</style>
